import type {LoginApiResponse, LoginResult} from "./login.types";

export const adaptLoginResponse = (response: LoginApiResponse): LoginResult => ({
  accessToken: response.data.access_token,
  refreshToken: response.data.refresh_token ?? null,
});
